import React, { useEffect, useState, useCallback } from "react";
import { Box, Grid, CircularProgress, Typography } from "@mui/material";
import { Group } from "@mui/icons-material";
import apiService from "../../../../service/Api";
import { EnhancedMetricCard } from "../admin-widgets/AdminDashboard";

const TotalCrewCard: React.FC = () => {
  const [totalCrew, setTotalCrew] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTotalCrew = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiService.get<{ count: number; results: any[] }>(
        "/api/crews/crew-members/"
      );
      setTotalCrew(response.data.count);
    } catch (err: any) {
      console.error(err);
      setError("Failed to load total crew members.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTotalCrew();
  }, [fetchTotalCrew]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, mt: 2 }}>
      <Grid container spacing={2} justifyContent="flex-start">
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <EnhancedMetricCard
            title="Total Crew"
            value={totalCrew}
            icon={Group}
            color="#4BA663"
            trend={7} // optional, you can remove or calculate dynamically
            subtitle="All Registered Crew"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TotalCrewCard;
